import customAxios from "../../customAxios";
import { DELETE_COMPANY } from "../../routes";
// import {DELETE_COMPANY} from "../../routes";

const deleteCompany = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_COMPANY + `/${userId}`)).data;
  } catch (error: any) {
    console.log({ DELETE_COMPANY: error });
    return false;
  }
};

export default deleteCompany;
